import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { EstadoSolicitud, Roles, SolicitudSeccion } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { ISolicitudModel } from 'src/app/models/interfaces/ISolicitudModel';
import { IFilterUsuarioModel } from 'src/app/models/interfaces/seguridad/IFilterUsuarioModel';
import { ISolicitudDocumentoTecnicoModel } from 'src/app/models/interfaces/solicitud/documento-tecnico/ISolicitudDocumentoTecnicoModel';
import { FilterUsuarioModel } from 'src/app/models/seguridad/FilterUsuarioModel';
import { EquipoModel } from 'src/app/models/solicitud/EquipoModel';
import { PersonalModel } from 'src/app/models/solicitud/PersonalModel';
import { SolicitudModel } from 'src/app/models/solicitud/SolicitudModel';
import { VehiculoModel } from 'src/app/models/solicitud/VehiculoModel';
import { UsuarioResultadoBusquedaModel } from 'src/app/models/usuario/UsuarioResultadoBusquedaModel';
import { SeguridadUsuarioService } from 'src/app/services/seguridad/seguridad-usuario.service';
import { SolicitudContratistaService } from 'src/app/services/solicitud-contratista/solicitud-contratista.service';
import { SolicitudDocumentosTecnicosService } from 'src/app/services/solicitud-documentos-tecnicos/solicitud-documentos-tecnicos.service';
import { SolicitudService } from 'src/app/services/solicitud/solicitud.service';
import { EquipoReadonlyDialogComponent } from '../equipo/equipo-readonly-dialog/equipo-readonly-dialog.component';
import { PersonalReadonlyDialogComponent } from '../personal/personal-readonly-dialog/personal-readonly-dialog.component';
import { VehiculoReadonlyDialogComponent } from '../vehiculo/vehiculo-readonly-dialog/vehiculo-readonly-dialog.component';
import * as fileSaver from 'file-saver';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { VisorPdfDocumentoModel } from 'src/app/models/common/VisorPdfDocumentoModel';
import { VisorPdfDialogComponent } from '../../shared/visor-pdf-dialog/visor-pdf-dialog.component';

@Component({
  selector: 'app-solicitud-aprobacion',
  templateUrl: './solicitud-aprobacion.component.html',
  styleUrls: ['./solicitud-aprobacion.component.css'],
})
export class SolicitudAprobacionComponent implements OnInit {
  public itemSolicitud: ISolicitudModel;
  displayedColumnsPersonal: string[] = [
    'nombre',
    'dni',
    'cargo',
    'estado',
    'acciones',
  ];
  displayedColumnsEquipos: string[] = [
    // 'equipo',

    'marca',
    'modelo',
    'serie',
    'estado',
    'acciones',
  ];
  displayedColumnsVehiculos: string[] = [
    'marca',
    'modelo',
    'placa',
    'color',
    'anio',
    'chofer',
    'estado',
    'acciones',
  ];

  displayedColumnsDocumentacionTecnica: string[] = [
    'nombre',
    'idRequisito',
    'fechaVencimiento',
    'idDocumento',
  ];

  @ViewChild('tablePersonal', { static: true, read: MatTable })
  table!: MatTable<any>;
  @ViewChild('tableEquipos', { static: true, read: MatTable })
  tableEquipos!: MatTable<any>;
  @ViewChild('tableVehiculos', { static: true, read: MatTable })
  tableVehiculos!: MatTable<any>;

  id: number;
  listaCoordinadores: UsuarioResultadoBusquedaModel[] =
    new Array<UsuarioResultadoBusquedaModel>();

  constructor(
    private route: ActivatedRoute,
    private solicitudService: SolicitudService,
    private solicitudContratistaService: SolicitudContratistaService,
    private usuarioService: SeguridadUsuarioService,
    private solicitudDocumentoTecnicoService: SolicitudDocumentosTecnicosService,
    public dialog: MatDialog,
    private router: Router,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) {
    this.itemSolicitud = new SolicitudModel();
    this.id = 0;
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params['id']; // (+) converts string 'id' to a number

      // In a real app: dispatch action to load the details here.
    });

    this.solicitudService
      .getById(this.id)
      .subscribe((data: ISolicitudModel) => {
        this.itemSolicitud = data;
        this.itemSolicitud.logs = this.itemSolicitud.logs.filter(p => p.comentarios != "" && p.comentarios != null);
        this.itemSolicitud.logsDocumentacionTecnica = this.itemSolicitud.logsDocumentacionTecnica.filter(p => p.comentarios != "");
        // this.itemSolicitud.personal = new Array<PersonalModel>();
        // this.itemSolicitud.equipos = new Array<EquipoModel>();
        // this.itemSolicitud.vehiculos = new Array<VehiculoModel>();

        this.itemSolicitud.comentarioPorAprobacionRechazo = "";

        let filterUsuario: IFilterUsuarioModel = new FilterUsuarioModel();
        filterUsuario.idRol = Roles.COORDINADOR_SSO;
        filterUsuario.idSede = this.itemSolicitud.idSede;

        this.usuarioService
          .getList(filterUsuario)
          .subscribe(
            (data: SearchResultModel<UsuarioResultadoBusquedaModel[]>) => {
              this.listaCoordinadores = data.items;
            }
          );
      });
  }

  openDialogPersonal(personal: PersonalModel): void {
    personal.idSolicitud = this.itemSolicitud.idSolicitud;
    personal.codigoSolicitud = this.itemSolicitud.codigo;

    const dialogRef = this.dialog.open(PersonalReadonlyDialogComponent, {
      width: '1000px',
      // data: { name: this.name, animal: this.animal}
      data: personal,
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }

  openDialogEquipo(equipo: EquipoModel): void {
    equipo.idSolicitud = this.itemSolicitud.idSolicitud;
    equipo.codigoSolicitud = this.itemSolicitud.codigo;

    const dialogRef = this.dialog.open(EquipoReadonlyDialogComponent, {
      width: '1000px',
      // data: { name: this.name, animal: this.animal}
      data: equipo,
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }

  openDialogVehiculo(vehiculo: VehiculoModel): void {
    vehiculo.idSolicitud = this.itemSolicitud.idSolicitud;
    vehiculo.codigoSolicitud = this.itemSolicitud.codigo;

    const dialogRef = this.dialog.open(VehiculoReadonlyDialogComponent, {
      width: '1000px',
      // data: { name: this.name, animal: this.animal}
      data: vehiculo,
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }

  aprobar(): void {
    if (
      this.itemSolicitud.idCoordinador == '' ||
      !this.itemSolicitud.idCoordinador
    ) {
      this.alertDialogService.open('Debe seleccionar un responsable de inducción.');
    } else {
      this.confirmDialogService.open('¿Está seguro de aprobar la solicitud?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          // this.itemSolicitud.idEstado = EstadoSolicitud.APROBADO;
          // this.solicitudService.aprobar(this.itemSolicitud).subscribe((p) => {
          //   this.alertDialogService.open('La solicitud fue APROBADA y enviada al responsable de inducción.');
          //   this.router.navigate(['/solicitudes', 'aprobacion']);
          // });
        }
      });
    }
  }

  rechazar(): void {
    if (
      this.itemSolicitud.comentarioPorAprobacionRechazo == '' ||
      !this.itemSolicitud.comentarioPorAprobacionRechazo
    ) {
      this.alertDialogService.open('Debe ingresar un comentario.');
    } else {
      this.confirmDialogService.open('¿Está seguro de rechazar la solicitud?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.itemSolicitud.idEstado = EstadoSolicitud.RECHAZADO;
          // this.solicitudService.aprobar(this.itemSolicitud).subscribe((p) => {
          //   this.alertDialogService.open('La solicitud fue RECHAZADA y enviada al solicitante para su revisión.');
          //   this.router.navigate(['/solicitudes', 'aprobacion']);
          // });
        }
      });
    }
  }

  downloadDocumentFromService(element: ISolicitudDocumentoTecnicoModel) {
    if (element.permiteVisor) {
      let modelVisor: VisorPdfDocumentoModel = new VisorPdfDocumentoModel();
      modelVisor.seccion = SolicitudSeccion.DocumentacionTecnica;
      modelVisor.idSolicitudDocumento = element.idSolicitudDocumentoTecnico;
      modelVisor.codigoSolicitud = this.itemSolicitud.codigo;
      modelVisor.nombreArchivo = element.nombreArchivo;
      const dialogVisroRef = this.dialog.open(VisorPdfDialogComponent, {
        width: '1300px',
        data: modelVisor,
        autoFocus: false,
      });
    }
    else {
      this.solicitudDocumentoTecnicoService.downloadDocumento(
        this.itemSolicitud.codigo,
        element.idSolicitudDocumentoTecnico
      ).subscribe(data => {
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        fileSaver.saveAs(blob, element.nombreArchivo);
      });
    }
  }
}
